import logo from 'assets/images/logo.jpg';

// ==============================|| LOGO ||============================== //

export default function LogoMain() {
  return <img src={logo} alt="Nexafarm" style={{ height: 32, width: 'auto', display: 'block' }} />;
}
